<template>
    <div class="innerBox" style="background-color: #092532; padding-top:18px">
        <div class="row" style="display: flex; justify-content: space-between;">
            <h5 class="text-white" style="margin:auto 0">Estimasi Sparepart</h5>
        </div>
        <div class="divider"></div>

        <div class="align-spacely" style="height:500px"><!-- HEIGHT HERE -->
            <div class="mini-stats row">
                <div class="col-8">
                    <h3 class="custom-text-pink">Total Part</h3>
                    <h3 class="text-white pl-3">{{ numberWithCommas(data.total) }}</h3>
                </div>
                <div class="col-4 icon">
                    <i class="fas fa-calculator"></i>
                </div>
            </div>

            <div class="divider"></div>

            <div class="row">
                <div class="col-4 text-center pt-3 pb-3" style="border-right:1px solid white">
                    <i class="fas fa-exclamation fa-3x" style="color:orange"></i>
                    <p class="estimation-status">Pending</p>
                    <p class="estimation-value">{{ numberWithCommas(data.pending) }}</p>
                </div>
                <div class="col-4 text-center pt-3 pb-3" style="border-right:1px solid white">
                    <i class="fas fa-check fa-3x" style="color:green"></i>
                    <p class="estimation-status">Approved</p>
                    <p class="estimation-value">{{ numberWithCommas(data.approved) }}</p>
                </div>

                <div class="col-4 text-center pt-3 pb-3">
                    <i class="fas fa-times fa-3x" style="color:red"></i>
                    <p class="estimation-status">Rejected</p>
                    <p class="estimation-value">{{ numberWithCommas(data.denied) }}</p>
                </div>
            </div>

            <div class="divider"></div>

            <div class="mini-stats row mt-3">
                <div class="col-12">
                    <h3 class="custom-text-pink">Total Jasa</h3>
                    <h3 class="text-white pl-3">{{ numberWithCommas(data.jasa) }}</h3>
                </div>
            </div>

            <div class="divider"></div>

            <div class="row">
                <div class="col-4 text-center pt-3 pb-3" style="border-right:1px solid white">
                    <i class="fas fa-exclamation fa-3x" style="color:orange"></i>
                    <p class="estimation-status">Pending</p>
                    <p class="estimation-value">{{ numberWithCommas(data.jasaPending) }}</p>
                </div>
                <div class="col-4 text-center pt-3 pb-3" style="border-right:1px solid white">
                    <i class="fas fa-check fa-3x" style="color:green"></i>
                    <p class="estimation-status">Approved</p>
                    <p class="estimation-value">{{ numberWithCommas(data.jasaApproved) }}</p>
                </div>

                <div class="col-4 text-center pt-3 pb-3">
                    <i class="fas fa-times fa-3x" style="color:red"></i>
                    <p class="estimation-status">Rejected</p>
                    <p class="estimation-value">{{ numberWithCommas(data.jasaDenied) }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {

            }
        },
        props : ['data'],
        mounted () {

        },
        methods : {

        }
    }
</script>

<style scoped>
    .innerBox {
        overflow-y: auto;
    }
</style>